import './HeadTurnArrowCue.css';

/**
 * Animated chevrons indicating which way to turn the head (left or right).
 * Used during side-profile capture alongside text guidance.
 */
export function HeadTurnArrowCue({ direction, accentColor = '#ffffff', className = '' }) {
  if (direction !== 'left' && direction !== 'right') return null;

  return (
    <div
      className={`head-turn-arrow-cue head-turn-arrow-cue--${direction} ${className}`.trim()}
      style={{ color: accentColor }}
      role="img"
      aria-label={direction === 'right' ? 'Turn head to the right' : 'Turn head to the left'}
    >
      {[0, 1, 2].map((i) => (
        <svg
          key={i}
          className="head-turn-arrow-cue__chevron"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden
        >
          {direction === 'right' ? (
            <polyline points="9 6 15 12 9 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          ) : (
            <polyline points="15 6 9 12 15 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          )}
        </svg>
      ))}
    </div>
  );
}
